import { Box } from '@mui/material';

const HelpCenter = () => <Box>HelpCenter</Box>;

export default HelpCenter;
